import { render, staticRenderFns } from "./InDmMessage.vue?vue&type=template&id=f657a74e&scoped=true"
import script from "./InDmMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InDmMessage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InDmMessage.vue?vue&type=style&index=0&id=f657a74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f657a74e",
  null
  
)

export default component.exports